<app-dc-header class="header">
  <ng-container class="heading">{{ distributorName ? distributorName : 'Distributor Contacts' }}</ng-container>
  <ng-container class="actions">
    <button type="button" class="btn btn-link downloadText d-flex align-item-center" (click)="refreshPage()">
      Refresh &nbsp;<i class="fas fa-refresh fs-4"></i>
    </button>
    <app-dc-download-csv
      [disabled]="disableCsvBtn"
      [fileTitle]="'Runs Summary '"
      (click)="downloadCsvRequest(true)"
      [title]="disableCsvBtn ? 'CSV Downloading...' : 'CSV Download'"
      #csvDownloadComponent
    ></app-dc-download-csv>
    <button type="button" class="btn btn-sm btn-primary" (click)="openAddContactModal(createContactModal)">
      Add Distributor Contact
    </button>
  </ng-container>
</app-dc-header>
<div class="nav">
  <a href="" [routerLink]="['/distributors']" class="btn btn-sm btn-tab">Distributors</a
  ><a href="" [routerLink]="['/distributors/contacts']" class="btn btn-sm btn-tab active">Contacts</a>
  <a href="" [routerLink]="['/files']" class="btn btn-sm btn-tab">Files</a>
</div>
<div class="d-block main">
  <app-dc-pane [noPadding]="false" [headerSearch]="true" [tableContainer]="true" [loading]="loading" class="d-block">
    <ng-container class="heading">List of Distributor Contacts</ng-container>
    <ng-container class="headingAction">
      <app-dc-table-search (searchValue)="updateFilter($event)"></app-dc-table-search>
    </ng-container>

    <app-dc-table
      *ngIf="rows?.length > 0"
      #table
      [rows]="rows"
      [columns]="columns"
      [messages]="messages"
      [sort]="sortOrder"
      [showFooter]="false"
      [scrollV]="true"
      (action)="tableAction($event)"
      (activate)="tableActivate($event)"
      [filterValue]="searchTextValue"
    ></app-dc-table>
    <div *ngIf="!loading && rows?.length < 1">
      <p class="lead text-center">No Distributor Contacts</p>
      <p class="text-muted text-center">Use the 'Add' button to create distributor contacts</p>
    </div>
    <!-- <div *ngIf="loading">
      <app-dc-loading class="contactsPadding"></app-dc-loading>
    </div> -->
  </app-dc-pane>
</div>
<ng-template #createContactModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">New Distributor Contact</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">Close</span>
    </button>
  </div>
  <div class="modal-body">
    <deltacapita-create-distributor-contact [modal]="modal"></deltacapita-create-distributor-contact>
  </div>
</ng-template>

<ng-template #actionButtonTemplate ngx-datatable-cell-template let-row="row" let-value="value">
  <div ngbDropdown class="d-inline-block" container="body" placement="right" display="dynamic">
    <fa-icon [icon]="faEllipsisV" class="mr-2 icon-color fa-lg" id="dropdownMenu1" ngbDropdownToggle></fa-icon>
    <div class="dropdown-menu" aria-labelledby="dropdownMenu1" ngbDropdownMenu>
      <button
        class="dropdown-item"
        [ngClass]="isContactAlreadyInvited(row) ? 'dropdown-item-disabled' : ''"
        (click)="openInviteModal(row)"
        [ngbPopover]="disabledAsAlreadyInvited"
        triggers="{{ isContactAlreadyInvited(row) ? 'mouseenter:mouseleave' : null }}"
      >
        <img class="mr-2" src="assets/publish_to_distributor.svg" /> Invite User to Platform
      </button>
      <button
        class="dropdown-item"
        [ngClass]="isContactAlreadyInvited(row) ? '' : 'dropdown-item-disabled'"
        (click)="openReinviteModal(row)"
        [ngbPopover]="disabledAsNotInvited"
        triggers="{{ isContactAlreadyInvited(row) ? null : 'mouseenter:mouseleave' }}"
      >
        <img class="mr-2" src="assets/mail.svg" /> Re-send Invitation
      </button>
      <button class="dropdown-item" (click)="editContactModal(editContactDataModal, row)">
        <img class="mr-2" src="assets/view_ddq.svg" /> Edit Distributor Contact
      </button>
      <button class="dropdown-item" (click)="openDeleteModal(row)">
        <img class="mr-2" src="assets/bin.svg" /> Delete Contact
      </button>
    </div>
  </div>
</ng-template>

<ng-template #disabledAsAlreadyInvited>
  <div [innerHtml]="'This user has already been invited to the platform.'"></div>
</ng-template>

<ng-template #disabledAsNotInvited>
  <div [innerHtml]="'This user has not been invited to the platform yet.'"></div>
</ng-template>

<ng-template #editContactDataModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Edit Distributor Contact</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">Close</span>
    </button>
  </div>
  <div class="modal-body">
    <deltacapita-edit-distributor-contact [modal]="modal"></deltacapita-edit-distributor-contact>
  </div>
</ng-template>

<ng-template #distributorNameLinkTemplate ngx-datatable-cell-template let-value="value" let-row="row">
  <span
    ><a class="name-link" [routerLink]="['/distributors', row.clientid]" [title]="value">
      {{ value }}
    </a></span
  >
</ng-template>

<ng-template #distributorContactLinkTemplate ngx-datatable-cell-template let-value="value" let-row="row">
  <span
    ><a class="name-link" [routerLink]="['/admin/user/list', row.email]" [title]="value">
      {{ value }}
    </a></span
  >
</ng-template>
